/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Membership_PerksInputs */

const en_membership_perks = /** @type {(inputs: Membership_PerksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Membership Perks`)
};

const es_membership_perks = /** @type {(inputs: Membership_PerksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beneficios de la Membresía`)
};

const fr_membership_perks = /** @type {(inputs: Membership_PerksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avantages de l'abonnement`)
};

const de_membership_perks = /** @type {(inputs: Membership_PerksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mitgliedschaftsvorteile`)
};

const id_membership_perks = /** @type {(inputs: Membership_PerksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keuntungan Keanggotaan`)
};

/** @type {(inputs: Membership_PerksInputs) => LocalizedString} */
const ja_membership_perks = en_membership_perks;

/** @type {(inputs: Membership_PerksInputs) => LocalizedString} */
const zh_membership_perks = en_membership_perks;

/** @type {(inputs: Membership_PerksInputs) => LocalizedString} */
const ar_membership_perks = en_membership_perks;

/** @type {(inputs: Membership_PerksInputs) => LocalizedString} */
const it_membership_perks = en_membership_perks;

/** @type {(inputs: Membership_PerksInputs) => LocalizedString} */
const ru_membership_perks = en_membership_perks;

/** @type {(inputs: Membership_PerksInputs) => LocalizedString} */
const pt_membership_perks = en_membership_perks;

/** @type {(inputs: Membership_PerksInputs) => LocalizedString} */
const ko_membership_perks = en_membership_perks;

/**
* | output |
* | --- |
* | "Membership Perks" |
*
* @param {Membership_PerksInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const membership_perks = /** @type {((inputs?: Membership_PerksInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Membership_PerksInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_membership_perks(inputs)
	if (locale === "es") return es_membership_perks(inputs)
	if (locale === "fr") return fr_membership_perks(inputs)
	if (locale === "de") return de_membership_perks(inputs)
	if (locale === "ja") return ja_membership_perks(inputs)
	if (locale === "zh") return zh_membership_perks(inputs)
	if (locale === "ar") return ar_membership_perks(inputs)
	if (locale === "id") return id_membership_perks(inputs)
	if (locale === "it") return it_membership_perks(inputs)
	if (locale === "ru") return ru_membership_perks(inputs)
	if (locale === "pt") return pt_membership_perks(inputs)
	return ko_membership_perks(inputs)
});